import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import healthSquare from './../../assets/images/health-shapes-square.svg';
import healthTriangle from './../../assets/images/health-shapes-triangle.svg';
import directChart from './../../assets/images/health-direct-chart.svg';
import '../health.scss';
import { gsap } from 'gsap';
import AOS from "aos";
import "aos/dist/aos.css";

export default function HealthPlanning() {

  const square1Ref = useRef();
  const square2Ref = useRef();
  const triangle1Ref = useRef();
  const triangle2Ref = useRef();

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {

    document.addEventListener('aos:in:bar-anim', function(ev) {
      //console.log('animated in', ev);

      if (ev.detail.querySelectorAll('.progress').length > 1) {
        console.log("more than 1 progress");
        var barArray = [...ev.detail.querySelectorAll('.progress')];
      } else {
        console.log("less than 1 progress");
        var barArray = [];
        var bar = ev.detail.querySelector('.progress');
        console.log(bar);
        barArray.push(bar);
      }

      console.log(barArray);

      if (barArray && barArray.length) {
        barArray.forEach(function(barItem) {
          var fill = barItem.getAttribute('data-fill');

          if (!ev.detail.classList.contains('vertical-bar-chart')) {
            barItem.style.width = fill + '%';
          }
        });
      }

      var Cont={val:0};

      if (ev.detail.querySelectorAll('.percentage').length > 1) {
        var percentageArray = [...ev.detail.querySelectorAll('.percentage')];
        console.log("more than 1 percentage");
      } else {
        var percentageArray = [];
        var percentage = ev.detail.children[0].querySelector('.percentage');
        percentageArray.push(percentage);
        console.log("less than percentage");

      }

      //console.log(percentage);

      if (percentageArray) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }

      console.log(percentageArray);

    });

    document.addEventListener('aos:in:percentage', function(ev) {
      var Cont={val:0};
      var percentage = ev.detail.children[0].querySelector('.percentage');
      var percentageArray = [];
      percentageArray.push(percentage);
      //console.log(percentage);

      if (percentage) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }
    });

    // Had to make some adjustments since it seemed like the animation wasn't playing nice with React. The shapes weren't incrementing exactly 90 degrees (it was adding a few degrees with decimal places) so they always rotated crooked. Possibly React strict mode causing issues. Added gsap.context, refs, and using GSAP's ScrollTrigger instead of AOS. 
    let ctx = gsap.context(() => {

      var tl = gsap.timeline({ 
        onComplete:rotateAgain,
        scrollTrigger: {
          trigger: ".shape-images"
        }
      });

      function animate(){
        tl
        .to(triangle1Ref.current, 0.5, {rotation:"+=90"})
        .to(square1Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(triangle2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(square2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
      }

      function rotateAgain(){
        gsap.delayedCall(5, animate)
      }

      animate();

    });

    return () => { ctx.revert(); /* <- cleanup! */ };

  }, []);

  useEffect(() => {
    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="health-planning">

        <p id="s1" className="intro" data-aos="fade-up">Explore key stats and insights to see how today’s health companies plan and manage direct mail.&#8288;<a href="#reference-1" className="cm-article-content__reference" aria-label="Footnote 1" title="Footnote 1"><sup aria-hidden="true">[1]</sup></a></p>
        <div className='two-cols'>
          <div className='col-right'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Direct Mail Expertise</h3>
                <div className='pie-chart' data-aos>
                  <svg viewBox="0 0 32 32" role="img" alt="" title="">
                    <circle r="16" cx="16" cy="16" strokeDasharray="0 100"></circle>
                  </svg>
                </div>

                <span data-aos data-aos-id="percentage" data-aos-anchor=".pie-chart">
                  <span data-aos className='percentage-value'><span class="percentage" data-to="52" aria-hidden="true">0</span><span class="screen-reader-text">52</span>%</span>
                </span>

                <p>Some knowledge, but not an expert</p>
                <p>Among all the respondents surveyed, those in health industries reported having the lowest expertise with direct mail.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>Having trouble getting started with direct mail, or just want a refresher? Brush up on the basics through a <strong><a href="/../dm-101-tutorial/">step-by-step beginner’s guide,</a> </strong> covering everything from data and mailing lists to ROI and postage.</p>
              </div>
            </div>

            
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Outside Agency Mail Management</h3>
                <div data-aos data-aos-id="percentage">
                  <span data-aos className='percentage-value large highlighter '><span class="percentage" data-to="36" aria-hidden="true">0</span><span class="screen-reader-text">36</span>%</span>
                </div>
                <p>Printing</p>
                <p><span className='text-large'>15%</span> Creative execution</p>
                <p>Health companies are the most likely to handle printing and creative execution through outside agencies, rather than handling these tasks in-house.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p><strong><a href="/../questions-to-ask-before-choosing-a-mail-service-provider/">Specialized partners</a></strong> can help you manage some—or all—elements of a direct mail campaign. Mail service providers (MSPs), advertising agencies and printers can help with various aspects, including writing and designing your piece, making sure it meets USPS requirements, printing and presorting, and more.</p>
              </div>
            </div> 
          </div>

          <div className='col-left'>           

            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Management of Direct Mail</h3>
                <p className="pull-quote">Across all industries, businesses usually have <span data-aos className='highlighter'>either in-house or agency-shared responsibility</span> for managing direct mail. In general, companies rarely depend solely on outside agencies.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>To help illuminate the most important aspects of direct mail campaigns, the United States Postal Service recently commissioned in-depth proprietary interviews with successful marketers, small business owners and printers to learn how they approach direct mail campaigns. Discover <a href="/../10-steps-direct-mail/">10 key tips</a> revealed by the research.</p>
              </div>
            </div>

            <div className='inner-cols'>
              <div className='inner-col-item'>
                <div className='rounded-box-module-wrap'>
                  <div className="rounded-box-module" data-aos="fade-up">
                    <h3>Direct Mail Format</h3>
                    <div className='progress-bar' data-aos data-aos-id="bar-anim">
                      <div className='progress' data-fill="53"><span class="percentage" data-to="53" aria-hidden="true">0</span><span class="screen-reader-text">53</span>%</div>
                    </div>
                    <p>First-Class Mail<sup>&reg;</sup> postcards</p>
                    <p>Health companies stand out for the propensity to use First-Class Mail postcards—rather than letters, brochures or other formats—in their mail campaigns.</p>
                  </div>
                  <div className="rounded-box-module">
                    <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                    <p>Postcards are ideal for conveying quick messages, sales announcements and immediate, easy-to-convey communications. <a href="/../what-is-the-right-size-for-your-direct-mailpiece">Use this quick guide</a> to compare them to other direct mail formats.</p>
                  </div>
                </div>
              </div>
              <div className='inner-col-item'>
                <div className='personalized-box secondary align-to-text'>
                  <h3 id="s2">The USPS Connect<sup>&trade;</sup> Local mail service&#8288;<a href="#reference-2" class="cm-article-content__reference" aria-label="Footnote 2" title="Footnote 2"><sup aria-hidden="true">[2]</sup></a> can be an ideal solution for health companies.</h3>
                  <div className='shape-images'>
                    <div className='triangle triangle-1'>
                      <img ref={triangle1Ref} src={healthTriangle} alt="" />
                    </div>
                    <div className='square square-1'>
                      <img ref={square1Ref} src={healthSquare} alt="" />
                    </div>
                    <div className='triangle triangle-2'>
                      <img ref={triangle2Ref} src={healthTriangle} alt="" />
                    </div>
                    <div className='square square-2'>
                      <img ref={square2Ref} src={healthSquare} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Direct Mail and USPS Services</h3>
                <div className='progress-bar-area' data-aos data-aos-id="bar-anim">
                  <div className='progressbar-item'>
                    <span className='label'>USPS Connect Local mail</span>
                    <div className='progress-bar size-small'>
                      <div className='progress' data-fill="62"><span class="percentage" data-to="62" aria-hidden="true">0</span><span class="screen-reader-text">62</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>Informed Delivery<sup>&reg;</sup></span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="48"><span class="percentage" data-to="48" aria-hidden="true">0</span><span class="screen-reader-text">48</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>Scheduled pickup</span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="48"><span class="percentage" data-to="48" aria-hidden="true">0</span><span class="screen-reader-text">48</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>Every Door Direct Mail<sup>&reg;</sup></span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="40"><span class="percentage" data-to="40" aria-hidden="true">0</span><span class="screen-reader-text">40</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>Informed Visibility<sup>&reg;</sup></span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="29"><span class="percentage" data-to="29" aria-hidden="true">0</span><span class="screen-reader-text">29</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>None of these</span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="2"><span class="percentage" data-to="2" aria-hidden="true">0</span><span class="screen-reader-text">2</span>%</div>
                    </div>
                  </div>
                </div>
                <p>Of various USPS services, health companies are most likely to use USPS Connect Local mail, a commercial First-Class Mail offering that allows businesses to deliver paper-based items same-day or next-day to local patients or customers. Health companies also use USPS Connect Local mail more than any other industry.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>The <strong><a href="https://www.usps.com/business/connect/" target="_blank" className="external-link">USPS Connect Local mail service</a></strong> can be an ideal and affordable solution for health companies that regularly send out time-sensitive communications or invoices, ensuring customers and patients get urgent information quickly and efficiently—and that it won’t be missed amid the digital clutter.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
